import React from 'react';
export function Guarantee() {
  const faqs = [{
    question: '¿Cómo recibo el producto?',
    answer: 'Es 100% digital. Después del pago recibís un email con el link de acceso inmediato. Podés descargarlo desde cualquier dispositivo, en cualquier momento, sin límite de veces.'
  }, {
    question: '¿Sirve si nunca cociné nada complicado?',
    answer: 'Sí, está diseñado exactamente para eso. Las instrucciones son gramo a gramo, paso a paso. Si podés mezclar ingredientes en un bowl, podés hacer estas barritas. El Bono de Recetas Sin Horno es el punto de partida ideal.'
  }, {
    question: '¿Es un pago único o hay suscripción?',
    answer: 'Pago único de $16.990. Sin cuotas mensuales, sin renovaciones, sin costos ocultos. Acceso de por vida a todo el material.'
  }];
  return <section className="bg-white py-12 sm:py-20 px-4" data-id="element-107">
      <div className="max-w-[780px] mx-auto" data-id="element-108">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-109" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-7 text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-110">
          Sin riesgo. El riesgo es todo mío.
        </h2>

        <div className="bg-[#F0FDF4] border-2 border-[rgba(34,197,94,0.4)] rounded-[28px] py-10 px-9 text-center max-w-[580px] mx-auto mb-[52px] relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[3px] before:bg-gradient-to-r before:from-transparent before:via-[#22C55E] before:to-transparent" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/gZwM7jFdprgDx1VriW6Av2/WhatsApp_Image_2026-04-17_at_08.38.12_(1).jpg" alt="Garantía 7 días" className="w-20 h-20 mx-auto mb-[14px] block rounded-full object-cover mix-blend-multiply" data-id="element-112" />
          <h2 className="font-montserrat text-[21px] font-extrabold text-[#15803D] mb-3" data-id="element-113">
            Garantía "Amalo o te lo Devuelvo" — 7 Días
          </h2>
          <p className="text-base text-[#475569] leading-[1.75]" data-id="element-114">
            Probá las recetas. Hacé tus primeras barritas.
            <br data-id="element-115" />
            Si en 7 días no sentís que ahorrás 10x el valor del libro, te
            devuelvo el{' '}
            <strong className="text-[#0F172A] font-semibold" data-id="element-116">
              100% de tu dinero. Sin preguntas. Sin letra chica.
            </strong>
          </p>
        </div>

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-117">
          Preguntas frecuentes
        </h2>

        <div className="max-w-[620px] mx-auto" data-id="element-118">
          {faqs.map((faq, idx) => <div key={idx} className="py-[22px] border-b border-[#E2E8F0] last:border-b-0" data-id="element-119">
              <p className="font-montserrat text-[15px] font-bold text-[#0F172A] mb-2 before:content-['→_'] before:text-[#F97316]" data-id="element-120">
                {faq.question}
              </p>
              <p className="text-sm text-[#475569] leading-[1.75]" data-id="element-121">
                {faq.answer}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}